// extracted by mini-css-extract-plugin
export default {"title":"Clients_title__x2Wae","list":"Clients_list__UOomC","logo":"Clients_logo__o26pb"};